

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");
import "@/store/modules/application";
const applicationState = namespace("Application");

import { pathwayTypeInfoType } from '@/types/Information';
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';

@Component
export default class DecisionOnLeaveToAppealAppApplyLeavePg extends Vue {  

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
    
    @informationState.Action
    public UpdatePathType!:(newPathType: pathwayTypeInfoType) => void

    public resToLeaveGrantedPath() {
        
        const pathType = {} as pathwayTypeInfoType;
        pathType.rspToLeaveGranted = true;
        this.UpdatePathType(pathType);                
        this.$emit('closeWindow');

    }

    public resToLeaveRefusedPath() {

        const pathType = {} as pathwayTypeInfoType;
        pathType.rspToLeaveRefused = true;
        this.UpdatePathType(pathType);
        this.$emit('closeWindow');
    }
}
